module.exports = __webpack_public_path__ + "media/subway/W-f023fdf2.png";